/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Media_Tab_Remove_ConfirmInputs */

const en_media_tab_remove_confirm = /** @type {(inputs: Media_Tab_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name}? This cannot be undone.`)
};

const fr_media_tab_remove_confirm = /** @type {(inputs: Media_Tab_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Supprimer ${i?.name} ? Cette opération est irréversible.`)
};

const de_media_tab_remove_confirm = /** @type {(inputs: Media_Tab_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Soll ${i?.name} entfernt werden? Dies kann nicht rückgängig gemacht werden.`)
};

const it_media_tab_remove_confirm = /** @type {(inputs: Media_Tab_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rimuovere ${i?.name}? Questa operazione non può essere annullata.`)
};

const ru_media_tab_remove_confirm = /** @type {(inputs: Media_Tab_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Удалить ${i?.name}? Это невозможно отменить.`)
};

const es_media_tab_remove_confirm = /** @type {(inputs: Media_Tab_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Eliminar ${i?.name}? Esto no se puede deshacer.`)
};

const zh_cn2_media_tab_remove_confirm = /** @type {(inputs: Media_Tab_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除${i?.name}？此操作无法撤销。`)
};

const ja_media_tab_remove_confirm = /** @type {(inputs: Media_Tab_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}を削除しますか？これは元に戻せません。`)
};

const hi_media_tab_remove_confirm = /** @type {(inputs: Media_Tab_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} को हटाएँ? इसे पूर्ववत नहीं किया जा सकता।`)
};

const pt_pt2_media_tab_remove_confirm = /** @type {(inputs: Media_Tab_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.name}? Esta ação não pode ser desfeita.`)
};

/**
* | output |
* | --- |
* | "Remove {name}? This cannot be undone." |
*
* @param {Media_Tab_Remove_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_remove_confirm = /** @type {((inputs: Media_Tab_Remove_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Remove_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_tab_remove_confirm(inputs)
	if (locale === "de") return de_media_tab_remove_confirm(inputs)
	if (locale === "it") return it_media_tab_remove_confirm(inputs)
	if (locale === "ru") return ru_media_tab_remove_confirm(inputs)
	if (locale === "es") return es_media_tab_remove_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_media_tab_remove_confirm(inputs)
	if (locale === "ja") return ja_media_tab_remove_confirm(inputs)
	if (locale === "hi") return hi_media_tab_remove_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_media_tab_remove_confirm(inputs)
	return en_media_tab_remove_confirm(inputs)
});